import PageDataContextService from "@core-ui/ContextServices/PageDataContext";
import { GesCloudConnectStorage } from "@ext/enterprise-cloud/components/Catalog/ConnectStorage";
import useHasRemoteStorage from "@ext/storage/logic/utils/useHasRemoteStorage";
import InitSource from "../../storage/components/InitSource";
import InitStorage from "../../storage/components/InitStorage";

export type ConnectStorageTrigger = (isLoading: boolean) => JSX.Element;

const DefaultConnectStorage = ({ trigger }: { trigger: ConnectStorageTrigger }) => {
	const hasRemoteStorage = useHasRemoteStorage();
	return hasRemoteStorage ? <InitSource trigger={trigger(false)} /> : <InitStorage trigger={trigger(false)} />;
};

const ConnectStorage = ({ trigger }: { trigger: ConnectStorageTrigger }) => {
	const { url: gesCloudUrl, enabled: cloudEnabled } = PageDataContextService.value.conf.enterpriseCloud;
	if (gesCloudUrl && cloudEnabled) return <GesCloudConnectStorage trigger={trigger} />;
	return <DefaultConnectStorage trigger={trigger} />;
};

export default ConnectStorage;
